// @todo esportare e verificare se valido per tutti gli ambienti
export const urlRegExp = /https:\/\/(.*)\.amazonaws\.com(\.cn)?\/(.*)\/(.\d{2,})\/(.\d{2,}).gbf/;
export const URL_REGEXP_ATHID = 5; // in base alla regexp sopra indica quale è la posizione della athleteSession id

export const SLOT_DURATION = 300000; // 5 minuti in s

export const BLOCK_MS = 5 * 60 * 10000;
export const STORE_NAME = 'session-data-state';

export const SESSION_DB_NAME = 'session-data-db';
/** v2: added the `session-manifest` store (v1 only had the blocks store) */
export const SESSION_DB_VERSION = 2;
export const MANIFEST_STORE = 'session-manifest';
export const DOWNLOAD_RETRY_DELAYS = [500, 1000, 2000]; // ms, 1 initial attempt + 3 retries
export const MAX_AUTO_REDOWNLOADS = 1;
